import { createStore } from 'vuex';
import moduleAuth from './modules/auth';

const store = createStore({
    modules: {
        auth: moduleAuth
    }
});

export default store;
